module.exports = __webpack_public_path__ + "img/Cisco_6841-51-61-71.9dcbbe0b.png";